import { Box } from '@mui/material'
import React from 'react'

import { FaultIconWithBorder } from 'components/common/FaultIcon'
import GlyphSubIcon from 'components/common/GlyphSubIcon'
import Icon from 'components/Icon'
import SvgHalted from 'components/icons/Halted'
import { getInfraCommandType } from 'components/scenarios/concurrent/attack-attributes'
import { useGetGraphNodeStatusColor } from 'components/scenarios/concurrent/use-get-graph-node-status-color'
import { getStateOfNodeByType } from 'components/scenarios/utils/graph-node-lifecycle'
import { isFailureFlagNode } from 'components/scenarios/utils/graph/nodes/typeguards'
import { muiTheme } from 'mui-theme'

import type {
  FailureFlagNode,
  InfraAttackNode
} from 'types/api/scenarios/scenario'

export const GraphNodeGlyphIcon: React.FC<{
  node: InfraAttackNode | FailureFlagNode
}> = ({ node }) => {
  const faultName = isFailureFlagNode(node)
    ? 'failureFlag'
    : getInfraCommandType(node)

  const { isHalted, isSuccessful, isFailed } = getStateOfNodeByType(node)

  const { isWarningInsteadOfError, statusBgColor } =
    useGetGraphNodeStatusColor(node)

  return (
    <Box
      sx={(muiTheme) => ({
        marginRight: muiTheme.spacing(2)
      })}
    >
      <FaultIconWithBorder
        faultName={faultName}
        iconColor={muiTheme.palette.text.primary}
      >
        {(isFailed || isHalted || isSuccessful) && (
          <GlyphSubIcon
            css={{
              background: statusBgColor,
              justifyContent: 'center'
            }}
            data-testid={`attack-graph-node-status-icon-bgcolor-${statusBgColor}`}
          >
            {isWarningInsteadOfError ? (
              <Icon css={{ paddingBottom: 1 }} icon="solidWarning" />
            ) : (
              isFailed && <Icon css={{ padding: 1 }} icon="solidClose" />
            )}
            {isHalted && <SvgHalted css={{ padding: 1 }} />}
            {isSuccessful && <Icon icon="solidCheck" />}
          </GlyphSubIcon>
        )}
      </FaultIconWithBorder>
    </Box>
  )
}
